import React, { useState, useEffect } from "react";
import infoIMG from "../../SVG/InformacionpersonalCenfotec.svg";
import { useForm, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerSolicitudInfoPersona,
  agregarSolicitudInfoPersona,
} from "../../redux/solicitudesSlice";
import { toast } from "react-toastify";
import OperationStatus from "../../config/OperationStatus";
import ReactSelect from "../../Components/ReactSelect";
import Required from "../../Components/Required";
import { getSolicitudPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { useValidation } from "../../Hooks/useValidation";
import { _translateValue } from "../../Adm/translation-gestor/translateValue";

const SCREEN_NAME = "PantallaPersonalInfo";

export default function PersonalInfo(props) {
  const [otrosCheck, setOtroCheck] = useState(false);
  const [pasaTiemposArray, setPasatiemposArray] = useState([]);
  const [anios, setAnios] = useState(0);
  const [listaPaises, setListaPaises] = useState([]);
  const [listaTiposDni, setListaTiposDni] = useState([]);
  const [listaGeneros, setListaGeneros] = useState([]);
  const [listaEstados, setListaEstados] = useState([]);
  const [listaFrecuencias, setListaFrecuencias] = useState([]);
  const { locale } = useLocale();
  const [solicitudPage, setSolicitudPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const { validation } = useValidation();
  const [translatedTiposDni, setTranslatedTiposDni] = useState({});
  const [translatedGeneros, setTranslatedGeneros] = useState({});
  const [translatedEstadosCiviles, setTranslatedEstadosCiviles] = useState({});
  const [translatedPaises, setTranslatedPaises] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);

  const dispatch = useDispatch();
  const { solicitudInfoPersona } = useSelector((state) => state.solicitudes);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "solicitudesRedesSociales",
  });
  const consultadoEnPadron = watch("consultadoEnPadron");

  const pasatiemposOtros = watch("pasaTiemposOtro");
  const pasatiempos = watch("pasaTiempos");
  const fechaN = watch("fechaNacimiento");
  useEffect(() => {
    dispatch(obtenerSolicitudInfoPersona(props.solicitudId));
  }, []);

  useEffect(() => {
    reset(solicitudInfoPersona);
  }, [solicitudInfoPersona]);

  useEffect(() => {
    if (pasatiemposOtros) setOtroCheck(true);
    else setOtroCheck(false);
  }, [pasatiemposOtros]);

  useEffect(() => {
    if (pasatiempos) {
      if (pasatiempos.length > 0) {
        setPasatiemposArray(pasatiempos);
      } else {
        setPasatiemposArray([]);
      }
    }
  }, [pasatiempos]);

  useEffect(() => {
    if (fechaN) verifyAge();
  }, [fechaN]);

  useEffect(() => {
    let a = solicitudInfoPersona?.paises?.map((item, i) => {
      return { label: translatedPaises[item.paisNombre] || item.paisNombre, value: item.paisId };
    });
    setListaPaises(a);
    let b = solicitudInfoPersona?.tiposDni?.map((item, i) => {
      return { label: translatedTiposDni[item.tipoDniNombre] || item.tipoDniNombre, value: item.tipoDniId };
    });
    setListaTiposDni(b);
    let c = solicitudInfoPersona?.generos?.map((item, i) => {
      return { label: translatedGeneros[item.generoNombre] || item.generoNombre, value: item.generoId };
    });
    setListaGeneros(c);
    let d = solicitudInfoPersona?.estadosCiviles?.map((item, i) => {
      return { label: translatedEstadosCiviles[item.estadoCivilNombre] || item.estadoCivilNombre, value: item.estadoCivilId };
    });
    setListaEstados(d);
    let e = solicitudInfoPersona?.redesSocialesFrecuenciasUso?.map(
      (item, i) => {
        return { label: item.frecuenciaUsoNombre, value: item.frecuenciaUsoId };
      }
    );
    setListaFrecuencias(e);
  }, [solicitudInfoPersona.paises, translatedTiposDni, translatedGeneros, translatedEstadosCiviles, translatedPaises]);

  const onSubmit = async (data) => {
    if (data.etapaActual === 1) data.etapaActual += 1;

    data.solicitudId = props.solicitudId;
    let { payload } = await dispatch(agregarSolicitudInfoPersona(data));

    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      props.onGoNext();
      props.handleStepChange(data.etapaActual);
    } else {
      toast.error(payload.message);
    }
  };

  const verifyAge = () => {
    let value = fechaN;
    var today = new Date();
    var birthDate = new Date(value);
    var anios = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      anios--;
    }
    setAnios(anios);
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getSolicitudPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setSolicitudPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setSolicitudPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los datos de los select cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasData = solicitudInfoPersona && (
        (solicitudInfoPersona.paises && solicitudInfoPersona.paises.length > 0) ||
        (solicitudInfoPersona.tiposDni && solicitudInfoPersona.tiposDni.length > 0) ||
        (solicitudInfoPersona.generos && solicitudInfoPersona.generos.length > 0) ||
        (solicitudInfoPersona.estadosCiviles && solicitudInfoPersona.estadosCiviles.length > 0)
      );

      // Si no hay datos, no hacer nada
      if (!hasData) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const tiposDniTranslations = {};
      const generosTranslations = {};
      const estadosCivilesTranslations = {};
      const paisesTranslations = {};
      const translationPromises = [];

      // Traducir tipos de DNI
      if (solicitudInfoPersona.tiposDni && Array.isArray(solicitudInfoPersona.tiposDni)) {
        solicitudInfoPersona.tiposDni.forEach((item) => {
          if (item.tipoDniNombre && !tiposDniTranslations[item.tipoDniNombre]) {
            tiposDniTranslations[item.tipoDniNombre] = null; // Marcador para evitar duplicados
            translationPromises.push(
              _translateValue(SCREEN_NAME, item.tipoDniNombre, locale).then((translated) => {
                tiposDniTranslations[item.tipoDniNombre] = translated;
              })
            );
          }
        });
      }

      // Traducir géneros
      if (solicitudInfoPersona.generos && Array.isArray(solicitudInfoPersona.generos)) {
        solicitudInfoPersona.generos.forEach((item) => {
          if (item.generoNombre && !generosTranslations[item.generoNombre]) {
            generosTranslations[item.generoNombre] = null; // Marcador para evitar duplicados
            translationPromises.push(
              _translateValue(SCREEN_NAME, item.generoNombre, locale).then((translated) => {
                generosTranslations[item.generoNombre] = translated;
              })
            );
          }
        });
      }

      // Traducir estados civiles
      if (solicitudInfoPersona.estadosCiviles && Array.isArray(solicitudInfoPersona.estadosCiviles)) {
        solicitudInfoPersona.estadosCiviles.forEach((item) => {
          if (item.estadoCivilNombre && !estadosCivilesTranslations[item.estadoCivilNombre]) {
            estadosCivilesTranslations[item.estadoCivilNombre] = null; // Marcador para evitar duplicados
            translationPromises.push(
              _translateValue(SCREEN_NAME, item.estadoCivilNombre, locale).then((translated) => {
                estadosCivilesTranslations[item.estadoCivilNombre] = translated;
              })
            );
          }
        });
      }

      // Traducir países
      if (solicitudInfoPersona.paises && Array.isArray(solicitudInfoPersona.paises)) {
        solicitudInfoPersona.paises.forEach((item) => {
          if (item.paisNombre && !paisesTranslations[item.paisNombre]) {
            paisesTranslations[item.paisNombre] = null; // Marcador para evitar duplicados
            translationPromises.push(
              _translateValue(SCREEN_NAME, item.paisNombre, locale).then((translated) => {
                paisesTranslations[item.paisNombre] = translated;
              })
            );
          }
        });
      }
      
      await Promise.all(translationPromises);

      // Actualizar estados y finalizar traducción
      setTranslatedTiposDni(tiposDniTranslations);
      setTranslatedGeneros(generosTranslations);
      setTranslatedEstadosCiviles(estadosCivilesTranslations);
      setTranslatedPaises(paisesTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [solicitudInfoPersona, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <form className="form-solicitud">
        <div className="form-c">
          <Skeleton active paragraph={{ rows: 4 }} />
          <Skeleton.Input style={{ width: '100%', height: 50 }} active />
          <Skeleton active paragraph={{ rows: 3 }} />
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-solicitud">
      <div className="form-c">
        <div className="title-container">
          <span className="form-title">{solicitudPage?.personal_info.title ||"Información personal"}</span>
        </div>
        <br />
        <div className="grid-container col-2 container">
          <div>
            <div className="grid-container col-2 col-lg-2 col-sm-12">
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.typeID || "Tipo identificación"}</label>
                  <Required />
                  <ReactSelect
                    name="tipoDniId"
                    control={control}
                    lista={listaTiposDni}
                    rules={{ required: validation?.required_field || "Campo requerido" }}
                    disabled={consultadoEnPadron}
                  />
                  {errors.tipoDniId && (
                    <p className="error">{errors.tipoDniId.message}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.numberID || "No. de identificación"}</label>
                  <Required />
                  <input
                    ref={register}
                    disabled={consultadoEnPadron}
                    {...register("dni", { required: validation?.required_field || "Campo requerido" })}
                    className="form-control"
                    type="text"
                  />
                  {errors.dni && <p className="error">{errors.dni.message}</p>}
                </div>
              </div>

              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.user_name || "Nombre(s)"}</label>
                  <Required />
                  <input
                    ref={register}
                    disabled={consultadoEnPadron}
                    {...register("nombres", { required: validation?.required_field || "Campo requerido" })}
                    name="nombres"
                    className="form-control"
                    type="text"
                  />
                  {errors.nombres && (
                    <p className="error">{errors.nombres.message}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.user_lastnameO || "Primer Apellido"}</label>
                  <Required />
                  <input
                    disabled={consultadoEnPadron}
                    ref={register}
                    {...register("primerApellido", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                    className="form-control"
                    type="text"
                  />
                  {errors.primerApellido && (
                    <p className="error">{errors.primerApellido.message}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.user_lastnameT || "Segundo Apellido"}</label>
                  <Required />
                  <input
                    ref={register}
                    disabled={consultadoEnPadron}
                    {...register("segundoApellido", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                    className="form-control"
                    type="text"
                  />
                  {errors.segundoApellido && (
                    <p className="error">{errors.segundoApellido.message}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.birthdate || "Fecha de nacimiento"}</label>
                  <Required />
                  <input
                    ref={register}
                    disabled={consultadoEnPadron}
                    className="form-control"
                    type="date"
                    name="fechaNacimiento"
                    {...register("fechaNacimiento", {
                      required: validation?.required_field || "Campo requerido",
                    })}
                  />
                  {anios > 0 && <span className="info">{anios} años</span>}
                  {errors.fechaNacimiento && (
                    <p className="error">{errors.fechaNacimiento.message}</p>
                  )}
                </div>
              </div>

              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.gender || "Género"}</label>
                  <Required />
                  <ReactSelect
                    name="generoId"
                    control={control}
                    lista={listaGeneros}
                    rules={{ required: validation?.required_field || "Campo requerido" }}
                  />
                  {errors.generoId && (
                    <p className="error">{errors.generoId.message}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.state || "Estado civil"}</label>
                  <Required />
                  <ReactSelect
                    name="estadoCivilId"
                    control={control}
                    lista={listaEstados}
                    rules={{ required: validation?.required_field || "Campo requerido" }}
                  />
                  {errors.estadoCivilId && (
                    <p className="error">{errors.estadoCivilId.message}</p>
                  )}
                </div>
              </div>
              <div className="grid-item">
                <div className="form-group">
                  <label>{solicitudPage?.personal_info.country || "País de procedencia"}</label>
                  <Required />

                  <ReactSelect
                    name="paisProcedenciaId"
                    control={control}
                    lista={listaPaises}
                    rules={{ required: validation?.required_field || "Campo requerido" }}
                  />
                  {errors.paisProcedenciaId && (
                    <p className="error">{errors.paisProcedenciaId.message}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="button-control">
            <img src={infoIMG} alt="ilustración Información personal" />
            <div>
              <button type="submit">{solicitudPage?.continue_button || "Continuar"}</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
